import React, { useState, useRef, useEffect, useCallback } from 'react';
import './AssignPathologistModal.css';
import { getIcon, Loader } from '@ohif/ui';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '@custom/store/store';
import assignPathologistApi from '@custom/rtk-apis/pathologistuser/assignPathologist';
import { AssignRadiologistProps } from '@custom/Utils/constants/interfaces';
import { useTheme } from "../../../ui/src/contextProviders"
import fetchPathologistUser from '@custom/rtk-apis/pathologistuser/getPathologistUser';
import { customStyle } from '@custom/Utils/utils';
import { servicesManager } from '../../../../platform/app/src/App';

const AssignPathologistModal: React.FC<AssignRadiologistProps> = ({ isOpen, onClose, patientId, wsiId, onAssignSuccess, modality }) => {
  const dispatch = useDispatch<AppDispatch>();
  const assignPathologiestResponse = useSelector(
    (state: RootState) => state.assignPathologistResponse
  );
  const { uiNotificationService } = servicesManager?.services;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [selectedPathologists, setSelectedPathologists] = useState<string[]>([]);
  const selectRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const [doctorData, setDoctorData] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState({});


  // API call on modal open
  useEffect(() => {
    if (isOpen && modality) {
      dispatch(fetchPathologistUser())
        .unwrap()
        .then(response => {
          setDoctorData(response?.result);
        })
        .catch(err => {
          console.error('API Error:', err);
        });
    }
  }, [isOpen, dispatch]);
  const handleAssign = async () => {
    const payload = {
      "patientId": patientId,
      "wsiId": wsiId,
      "pathologistId": selectedDoctor?._id
    }
    setIsLoading(true);
    setIsAssigning(true);
    await dispatch(assignPathologistApi(payload));

  };
  useEffect(() => {
      if (isAssigning && assignPathologiestResponse.status === 'SUCCESS' ) {
        setIsLoading(false);
        setIsAssigning(false);
        onAssignSuccess(selectedDoctor);
      }
      if(isAssigning && assignPathologiestResponse.status === 'ERROR') {
        setIsLoading(false);
        setIsAssigning(false);
        setIsLoading(false);
        uiNotificationService.show({
          title: 'Assign Pathologiest',
          message: assignPathologiestResponse.msg,
          type: 'error',
        })
      }
    setIsLoading(false);
  },[assignPathologiestResponse])

  useEffect(() => {
    if (!isOpen) {
      setSelectedPathologists([]);
      setIsDropdownOpen(false);
    }
  }, [isOpen]);

  const updateDropdownWidth = useCallback(() => {
    if (selectRef.current && dropdownRef.current) {
      dropdownRef.current.style.width = `${selectRef.current.offsetWidth}px`;
    }
  }, [selectRef.current?.offsetWidth]);

  useEffect(() => {
    updateDropdownWidth();
    window.addEventListener('resize', updateDropdownWidth);

    return () => {
      window.removeEventListener('resize', updateDropdownWidth);
    };
  }, [updateDropdownWidth]);

  const handleRowClick = (doctorId: string) => {
    const selectedDoctor = doctorData.find(doctor => doctor._id === doctorId);
    if (selectedDoctor) {

      setSelectedDoctor(selectedDoctor);
      setSelectedPathologists(prevSelected => {
        return prevSelected.includes(selectedDoctor.name) ? [] : [selectedDoctor.name];
      });
    }
  };

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef, selectRef]);

  if (!isOpen) return null;


  const isDarkMode = useTheme();

  return (
    <div className="modal-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center" style={{ zIndex: 9999 }}>
      <div className="modal-container w-[32rem] bg-white p-6 rounded-lg shadow-lg radiologist-popup">
        <div className='modal-header'>
          <h2 className="text-xl font-semibold">Assign Pathologist</h2>
          <button onClick={onClose} className="icon icon-header">
            {getIcon('CrossIcon', { height: '16px', width: '16px' })}
          </button>
        </div>
        <div className='formRow'>
          <div className='formCol'>
            <div className='form__Field'>
              <label className="form__label" htmlFor="pathologistSelect">Select Pathologist</label>
              <select
                id="pathologistSelect"
                name="pathologist"
                value={selectedDoctor?._id}
                onChange={(e) => handleRowClick(e.target.value)}
                className="form__select form__select--sm"
                style={customStyle.select}
              >
                <option value="">Select</option>
                {isLoading ? (
                  <option disabled>Loading...</option>
                ) : (
                  doctorData.map((doctor) => (
                    <option key={doctor._id} value={doctor._id}>
                      {doctor?.name}
                    </option>
                  ))
                )}
              </select>
            </div>
          </div>
        </div>

        <div className='btn__group'>
          <button className="btn btn__white" onClick={onClose}>Cancel</button>
          <button className="btn btn__primary" onClick={handleAssign}>Assign</button>
        </div>
      </div>
      <Loader isLoaderOpen={isLoading}></Loader>
    </div>
  );
};

export default AssignPathologistModal;
